import { ReactElement } from 'react';

import { Container, FilledBar, UnfilledBar, UnfilledBarContainer } from './styles';
import { ProgressBarProps } from './types';

const ProgressBar = ({ percentComplete, filledBackground, ...props }: ProgressBarProps): ReactElement => {
	const percentLeft = 100 - percentComplete;

	return (
		<Container role="progressbar" aria-valuenow={percentComplete} {...props}>
			<UnfilledBarContainer>
				<UnfilledBar percentLeft={percentLeft} />
			</UnfilledBarContainer>
			<FilledBar filledBackground={filledBackground} />
		</Container>
	);
};

export default ProgressBar;
